let list_itc = [
    {
        id: "na",
        name: "Not Applicable / Unknown"
    },
    {
        id: "access",
        name: "access"
    },
    {
        id: "connect",
        name: "connect"
    },
    {
        id: "hcc",
        name: "hcc"
    },
    {
        id: "laca",
        name: "laca"
    },
    {
        id: "lgca",
        name: "lgca"
    },
    {
        id: "mveca",
        name: "mveca"
    },
    {
        id: "ncocc",
        name: "ncocc"
    },
    {
        id: "neomin",
        name: "neomin"
    },
    {
        id: "neonet",
        name: "neonet"
    },
    {
        id: "noacsc",
        name: "noacsc"
    },
    {
        id: "noeca",
        name: "noeca"
    },
    {
        id: "nwoca",
        name: "nwoca"
    },
    {
        id: "ome-resa",
        name: "ome_resa"
    },
    {
        id: "sparcc",
        name: "sparcc"
    },
    {
        id: "swoca",
        name: "swoca"
    },
    {
        id: "tccsa",
        name: "tccsa"
    },
    {
        id: "woco",
        name: "woco"
    }

];

export function getListITC() {
    return list_itc;
}
